export interface Article {
  id: number;
  title: string;
  excerpt: string;
  category: string;
  readTime: string;
  lastUpdated: string;
  slug: string;
  author: string;
  toolsMentioned: string[]; // References to tool slugs
}

export const articles: Article[] = [
  {
    id: 1,
    title: "Welcome to ChooseAI",
    excerpt: "Discover how ChooseAI can help you find the perfect AI tools for your needs",
    category: "News",
    readTime: "3 min read",
    lastUpdated: "2026-01-02",
    slug: "welcome-to-chooseai",
    author: "ChooseAI",
    toolsMentioned: []
  },
  {
    id: 2,
    title: "The 2026 AI Tech Stack: 10 Must-Have Tools for Small Business Owners",
    excerpt: "AI is transforming the way small businesses operate. Here are 10 essential AI tools to include in your tech stack this year.",
    category: "List",
    readTime: "10 min read",
    lastUpdated: "2026-02-22",
    slug: "2026-ai-tech-stack",
    author: "ChooseAI",
    toolsMentioned: ["hubspot", "microsoft-copilot", "gemini", "writesonic", "descript", "midjourney", "elevenlabs", "synthesia", "grammarly", "lovable"]
  },
  {
    id: 3,
    title: "Automate Youtube: The Ultimate Guide to Building a Profitable Faceless YouTube Channel in 2026",
    excerpt: "Learn how to leverage AI tools to create and grow a successful faceless YouTube channel.",
    category: "Guide",
    readTime: "15 min read",
    lastUpdated: "2026-02-22",
    slug: "automate-youtube-2026",
    author: "ChooseAI",
    toolsMentioned: ["chatgpt", "synthesia", "runway", "descript"]
  },
  {
    id: 4,
    title: "Beyond the Blue Link: Why does SEO and GEO matter in 2026",
    excerpt: "Learn how to apply SEO and GEO optimisation within your business, and how AI can help with this.",
    category: "Learn",
    readTime: "10 min read",
    lastUpdated: "2026-02-22",
    slug: "seo-geo-2026",
    author: "ChooseAI",
    toolsMentioned: ["chatgpt", "writesonic", "jasper", "grammarly", "lovable", "replit", "hubspot", "descript", "elevenlabs", "synthesia", "browse-ai"]
  },
  {
    id: 5,
    title: "The AI Receptionist: How to Build a 24/7 Voice Agent with ElevenLabs and Vapi",
    excerpt: "Learn how to use ElevenLabs and Vapi to build an AI-powered receptionist that can take customer calls, manage calendars and represents your business well.",
    category: "Guide",
    readTime: "20 min read",
    lastUpdated: "2026-02-22",
    slug: "ai-receptionist-elevenlabs",
    author: "ChooseAI",
    toolsMentioned: ["elevenlabs", "vapi"]
  },
  {
    id: 6,
    title: "Building a Podcasting Empire on a Budget: The AI Blueprint",
    excerpt: "Podcasts have become an essential medium for small businesses to stand out, AI can help level the playing field without buying expensive gear.",
    category: "Guide",
    readTime: "10 min read",
    lastUpdated: "2026-02-22",
    slug: "podcast-on-budget",
    author: "ChooseAI",
    toolsMentioned: ["chatgpt", "claude", "jasper", "descript", "elevenlabs", "murf-ai", "synthesia", "midjourney", "stability-ai", "canva", "lovable", "replit", "grammarly", "writesonic", "browse-ai"]
  },
  
];

export const getArticlesByTool = (toolSlug: string): Article[] => {
  return articles.filter(article => article.toolsMentioned.includes(toolSlug));
};

export const getFeaturedArticle = (): Article => {
  return articles[0];
};

export const getArticlesByCategory = (category: string): Article[] => {
  if (category === 'All') return articles;
  return articles.filter(article => article.category === category);
};

export const getArticleCategories = (): string[] => {
  return ['All', ...Array.from(new Set(articles.map(article => article.category)))];
};

export const formatLastUpdated = (dateString: string): string => {
  return `Updated ${new Date(dateString).toLocaleDateString('en-GB', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })}`;
};

export const formatDate = (dateString: string): string => {
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};